export default "__VITE_PUBLIC_ASSET__ca849239__"